<template>
  <div class="form-coms ui-textarea">
    <div class="form-label" v-if="$attrs.label">{{ $attrs.label }}</div>
    <textarea
      v-bind="$attrs"
      v-model="vmodel"
      :style="{
        width: width,
      }"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: 'Input',
  data: () => ({
    val: '',
  }),
  props: {
    value: String,
    width: {
      type: String,
      default: '230px',
    },
  },
  computed: {
    vmodel: {
      get() {
        return this.val
      },
      set(val) {
        this.val = val
        this.$emit('update:value', val)
      },
    },
  },
  watch: {
    value(val) {
      this.val = val
    },
  },
}
</script>
<style lang="scss">
.ui-textarea {
  margin-bottom: 8px;
  font-size: 14px;

  .form-label {
    text-align: left;
    font-size: 14px;
  }
  textarea {
    padding: 8px 12px;
    background: rgba(200, 200, 200, 0.2);
    border-radius: 2px;
    border-radius: 6px;
    // border-bottom: 1px solid silver;
    max-width: 100%;

    &:hover,
    &:focus {
      border: 0;
      background: rgba(200, 200, 200, 0.4);
      // border-bottom: 1px solid gray;
    }
  }
}
.form-inline,
.inline-form {
  .ui-textarea {
    textarea {
      height: 100%;
    }
  }
}
.is-mobile {
  .ui-textarea {
    textarea {
      height: calc(100% - 28px);
    }
  }
}
</style>
